import { Pipe, PipeTransform } from '@angular/core';
import { AutoRunSnapshot } from '../models/auto-run-report-snapshots.model';

@Pipe({
    name: 'snapshotInFolderFilter',
    pure: false
})
export class SnapshotInFolderFilter implements PipeTransform {

    transform(snapshots: AutoRunSnapshot[], folderSearch: string, reportSearch: string): AutoRunSnapshot[] {
        // console.log(snapshots);
        // console.log(folderSearch);
        // console.log(reportSearch);

        if (snapshots != null) {
            return snapshots.filter(

                snapshot =>
                (folderSearch == undefined || folderSearch == 'All' || snapshot.FolderName == folderSearch)
                && (reportSearch == undefined || reportSearch == 'All' || snapshot.ReportName == reportSearch)
            );

        }
    }


}